// src/pages/CompaniesPage/companyDialog/sections/SectionHotel.jsx
import React, { useMemo } from "react";
import {
    Box,
    TextField,
    FormControlLabel,
    Switch,
    Typography,
} from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";

function WysiwygField({ label, value, onChange, height = 220 }) {
    const init = useMemo(
        () => ({
            license_key: "gpl", // required for TinyMCE 6 community edition
            height,
            menubar: false,
            branding: false,
            statusbar: false,
            plugins: "lists link autolink",
            toolbar:
                "undo redo | bold italic underline | bullist numlist | link | removeformat",
            content_style:
                "body { font-family: Inter, Arial, sans-serif; font-size: 14px; padding: 8px; }",
        }),
        [height]
    );

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {label}
            </Typography>

            <Box
                sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1.5,
                    overflow: "hidden",
                    backgroundColor: "background.paper",
                }}
            >
                <Editor
                    tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
                    value={value ?? ""}
                    init={init}
                    onEditorChange={(html) => onChange(html)}
                />
            </Box>
        </Box>
    );
}

export default function SectionHotel({ form, setForm }) {
    return (
        <>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    gap: 2,
                }}
            >
                <FormControlLabel
                    control={
                        <Switch
                            checked={!!form.homepage_mobile_optimized}
                            onChange={(e) =>
                                setForm((f) => ({
                                    ...f,
                                    homepage_mobile_optimized: e.target.checked,
                                }))
                            }
                        />
                    }
                    label="Homepage für Smartphone optimiert"
                />

                <Box />

                <TextField
                    label="Kundenlink für Reservierung"
                    value={form.customer_link_reservation ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({ ...f, customer_link_reservation: e.target.value }))
                    }
                />
                <TextField
                    label="Kundenlink für virtuelle Tour"
                    value={form.customer_link_virtual_tour ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({
                            ...f,
                            customer_link_virtual_tour: e.target.value,
                        }))
                    }
                />
                <TextField
                    label="Kundenlink Video"
                    value={form.customer_link_video ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({ ...f, customer_link_video: e.target.value }))
                    }
                />
                <TextField
                    label="Kundenlink Webcam"
                    value={form.customer_link_webcam ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({ ...f, customer_link_webcam: e.target.value }))
                    }
                />

                <TextField
                    label="Ruhetage"
                    value={form.closing_days ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({ ...f, closing_days: e.target.value }))
                    }
                />
                <TextField
                    label="Sommer- & Wintersaison"
                    value={form.summer_winter_season ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({
                            ...f,
                            summer_winter_season: e.target.value,
                        }))
                    }
                />
                <TextField
                    label="Betriebsferien"
                    value={form.company_holidays ?? ""}
                    onChange={(e) =>
                        setForm((f) => ({
                            ...f,
                            company_holidays: e.target.value,
                        }))
                    }
                />

                {/* WYSIWYG nebeneinander */}
                <Box
                    sx={{
                        gridColumn: "1 / -1",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                        gap: 2,
                        alignItems: "stretch",
                    }}
                >
                    <WysiwygField
                        label="Öffnungszeiten"
                        value={form.opening_hours}
                        onChange={(html) =>
                            setForm((f) => ({
                                ...f,
                                opening_hours: html,
                            }))
                        }
                        height={220}
                    />

                    <WysiwygField
                        label="Info"
                        value={form.info}
                        onChange={(html) =>
                            setForm((f) => ({ ...f, info: html }))
                        }
                        height={220}
                    />
                </Box>
            </Box>
        </>
    );
}
